import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Table,
  TableContainer,
  Divider,
  Tooltip,
  IconButton,
} from "@mui/material";
import PrivateLayout from "layouts/privateLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DateTimeFormatter from "helper/dateTimeFormartter";
import TaxType from "../../data/taxType.json";
import CountryCode from "../../data/countryCode.json";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import QRCode from "react-qr-code";

import axios from "axios";
import { tokens } from "../../theme";
import ChipComponent from "components/chip";
import { useApiClient } from "context/ApiClientContext";

const DetailItem = ({ label, value, justify }) => (
  <Box display="flex" alignItems="top" justifyContent={justify}>
    <Typography variant="subtitle1">{label}</Typography>
    {value ? <Typography variant="subtitle1">: {value}</Typography> : " "}
  </Box>
);

export default function DetailsInfo() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // const navigate = useNavigate();
  const apiClient = useApiClient();

  const { id } = useParams();
  const [data, setData] = useState({
    invoiceInfo: {},
    supplierInfo: {},
    productInfo: [],
    requestInfo: [],
    buyerInfo: {},
  });

  const dateTimeFormatter = DateTimeFormatter();

  const getOne = async (id) => {
    try {
      const response = await axios.get(
        `${apiClient}/${localStorage.getItem(
          "companyId"
        )}/document/${id}?filters=pagination[page]=1`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );

      const dataRows = response.data;

      const invoiceInfo = {
        company: dataRows.companyId,
        docSource: dataRows.docSource,
        typeCode: dataRows.typeCode,
        type: dataRows.typeCode_Value,
        number: dataRows.docNum,
        oriRefNumber: dataRows.refDocNum,
        issuanceDate: dateTimeFormatter.format(dataRows.issueDateTime),
        currencyCode: dataRows.currency,
        exchangeRate: dataRows.exchangeRate,
        billFreq: dataRows.billFreq,
        billPeriod: "",
        irbm: dataRows.eDocNum,
        validationDate: dateTimeFormatter.format(dataRows.docDueDate),
        version: dataRows.version,
        signature: dataRows.signature,
        date: dateTimeFormatter.format(dataRows.docDate),
        payMode: dataRows.payMode,
        payMode_Value: dataRows.payMode_Value,
        payTerm: dataRows.payTerm,
        depositAmt: dataRows.depositAmt,
        depositDateTime: dateTimeFormatter.format(dataRows.depositDateTime),
        depositNum: dataRows.depositNum,
        depositRefNum: dataRows.depositRefNum,
        total_ExcludeTax: dataRows.total_ExcludeTax,
        total_IncludeTax: dataRows.total_IncludeTax,
        total_PayableAmt: dataRows.total_PayableAmt,
        total_NettAmt: dataRows.total_NettAmt,
        total_DiscAmt: dataRows.total_DiscAmt,
        total_ChargeAmt: dataRows.total_ChargeAmt,
        total_TaxAmt: dataRows.total_TaxAmt,
        roundingAmt: dataRows.roundingAmt,
        total_TaxableAmt: dataRows.total_TaxableAmt,
        total_TaxTypeAmt: dataRows.total_TaxTypeAmt,
        taxType: dataRows.taxType,
        taxType_Value: dataRows.taxType_Value,
        status: dataRows.status,
        remark: dataRows.remark,
        addedBy: dataRows.addedBy,
        addedDate: dateTimeFormatter.format(dataRows.addedDate),
        updatedBy: dataRows.updatedBy,
        updatedDate: dateTimeFormatter.format(dataRows.updatedDate),
      };

      const supplierInfo = {
        id: dataRows.supID,
        name: dataRows.supplier_Name,
        email: dataRows.supplier_Email,
        phone: dataRows.supplier_Contact,
        msicNum: dataRows.supplier_MSIC,
        accNum: dataRows.supBankAcctNum,
        tin: dataRows.supplier_Tin,
        sst: dataRows.supplier_SST,
        tourismTaxNum: dataRows.supplier_TourismTax,
        address:
          dataRows.supplier_Addr0 +
          " " +
          dataRows.supplier_Addr1 +
          " " +
          dataRows.supplier_Addr2 +
          " " +
          dataRows.supplier_Zipcode +
          " " +
          dataRows.supplier_City,
        state: dataRows.supplier_State,
        country: dataRows.supplier_Country,
        bussinessDesc: dataRows.supplier_BizNature,
        bussinessType: dataRows.supplier_BizType,
        bussinessValue: dataRows.supplier_BizValue,
      };

      const buyerInfo = {
        id: dataRows.buyID,
        name: dataRows.buyer_Name,
        email: dataRows.buyer_Email,
        phone: dataRows.buyer_Contact,
        tin: dataRows.buyer_Tin,
        sst: dataRows.buyer_SST,
        address:
          dataRows.buyer_Addr0 +
          " " +
          dataRows.buyer_Addr1 +
          " " +
          dataRows.buyer_Addr2 +
          " " +
          dataRows.buyer_Zipcode +
          " " +
          dataRows.buyer_City,
        state: dataRows.buyer_State,
        country: dataRows.buyer_Country,
        bussinessType: dataRows.buyer_BizType,
        bussinessValue: dataRows.buyer_BizValue,
      };

      const productInfo = dataRows.docDetails;

      productInfo.map((data, i) => {
        mappingValue(data, "taxTypeId", TaxType, "taxType");
        mappingValue(data, "originCountry", CountryCode, "originCountry");
      });

      const requestInfo = [];

      setData({
        invoiceInfo,
        supplierInfo,
        productInfo,
        requestInfo,
        buyerInfo,
      });
    } catch (error) {
      console.error("An error occurred:", error.response);
    }
  };

  function mappingValue(data, field, mapping, newField) {
    if (field in data) {
      const dataField = data[field];
      const matchingDescription = mapping.find((item) => {
        if (mapping === "TaxType") {
          if (item.Code === 0 + dataField) {
            return item;
          }
        } else {
          if (item.Code === dataField) {
            return item;
          }
        }
      });

      if (matchingDescription) {
        const desc = matchingDescription.Description;
        data[newField] = desc;
      }
    }
  }

  const structredList = async (data) => {
    const dataRows = data.row;

    let requestInfo = [];
    if (dataRows.request) {
      requestInfo = [
        {
          tranId: dataRows.id,
          invNum: dataRows.eInvNum,
          id: dataRows.request.id,
          reqHeader: dataRows.request.attributes.reqHeader,
          reqBody: dataRows.request.attributes.reqBody,
          reqDate: dataRows.request.attributes.reqDate,
          reqParam: dataRows.request.attributes.reqParam,
          reqUrl: dataRows.request.attributes.reqUrl,
          rtnHeader: dataRows.request.attributes.rtnHeader,
          rtnBody: dataRows.request.attributes.rtnBody,
          rtnStatusCode: dataRows.request.attributes.rtnStatusCode,
          rtnDate: dataRows.request.attributes.rtnDate,
          createdAt: dataRows.request.attributes.createdAt,
          publishedAt: dataRows.request.attributes.publishedAt,
          updatedAt: dataRows.request.attributes.updatedAt,
        },
      ];
    } else {
      requestInfo = [];
    }

    setData({
      requestInfo,
    });
  };

  useEffect(() => {
    getOne(id);
    // structredList(dataRows);
  }, []);

  return (
    <PrivateLayout >
     <Box  border={1} px={2}>
     <Box display="flex" justifyContent="center" m={2} >
        <Box>
          <Typography
            textAlign="center"
            variant="h5"
            uppercase
            sx={{ fontWeight: "bold", textTransform: "uppercase" }}
          >
            {data.supplierInfo.name}
          </Typography>
          <Typography textAlign="center">
            {data.supplierInfo.address +
              ", " +
              data.supplierInfo.state +
              ", " +
              data.supplierInfo.country}
          </Typography>
          <Typography textAlign="center">{data.supplierInfo.phone}</Typography>
        </Box>
      </Box>

      <Divider mb={3} />

      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
            <DetailItem
              label={"Supplier TIN"}
              value={data.supplierInfo.tin}
              justify="start"
            />
            <DetailItem
              label={"Supplier Registration Number"}
              value={data.supplierInfo.bussinessValue}
              justify="start"
            />
            <DetailItem
              label={"Supplier SST Number"}
              value={data.supplierInfo.sst}
              justify="start"
            />

            <DetailItem
              label={" Supplier MSIC Code"}
              value={data.supplierInfo.msicNum}
              justify="start"
            />
            <DetailItem
              label={"Supplier Bussiness Description"}
              value={data.supplierInfo.bussinessDesc}
              justify="start"
            />
            <Box m={2} />
            <DetailItem
              label={"Buyer TIN"}
              value={data.buyerInfo.tin}
              justify="start"
            />
            <DetailItem
              label={"Buyer Name"}
              value={data.buyerInfo.name}
              justify="start"
            />
            <DetailItem
              label={"Buyer Registration Number"}
              value={data.buyerInfo.bussinessValue}
              justify="start"
            />
            <DetailItem
              label={"Buyer SST Number"}
              value={data.buyerInfo.sst}
              justify="start"
            />
            <DetailItem
              label={"Buyer Phone Number"}
              value={data.buyerInfo.phone}
              justify="start"
            />
            <DetailItem
              label={"Buyer Email"}
              value={data.buyerInfo.email}
              justify="start"
            />
            {/* <DetailItem
                label={"Address"}
                value={
                  data.buyerInfo.address +
                  ", " +
                  data.buyerInfo.state +
                  ", " +
                  data.buyerInfo.country
                }
                justify="start"
              /> */}
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              textAlign="right"
              variant="h6"
              mb={2}
              sx={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              E-Invoice
            </Typography>

            <DetailItem
              label={"e-invoice Type"}
              value={data.invoiceInfo.typeCode + data.invoiceInfo.type}
              justify="end"
            />
            <DetailItem
              label={"e-invoice Version"}
              value={data.invoiceInfo.version}
              justify="end"
            />
            <DetailItem
              label={"e-invoice Code"}
              value={data.invoiceInfo.number}
              justify="end"
            />
            <DetailItem
              label={"Unique Identifier No."}
              value={data.invoiceInfo.irbm || "Not Applicable"}
              justify="end"
            />
            <DetailItem
              label={"Original Invoice Ref. No."}
              value={data.invoiceInfo.oriRefNumber}
              justify="end"
            />
            <DetailItem
              label={"Invoice Date"}
              value={data.invoiceInfo.date}
              justify="end"
            />
          </Grid>
        </Grid>
      </Box>

      <TableContainer component={Paper} sx={{ marginTop: "20px" }}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 1,
                  borderColor: "#ccc",
                  background: "#000",
                  color: "#fff!important",
                },
              }}
            >
              <TableCell>Classification</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Unit Price</TableCell>
              <TableCell>Disc</TableCell>
              <TableCell>Tax Rate</TableCell>
              <TableCell>Tax Amount</TableCell>
              <TableCell>Total Product (incl. tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.productInfo.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12}>
                  <Typography textAlign="center" color="lightgray">
                    No Data Available
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.productInfo.map((row, i) => (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 1,
                      borderColor: "#ccc",
                    },
                  }}
                >
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    <Box>
                      <Typography>{row.classId || "-"}</Typography>
                    </Box>
                  </TableCell>

                  <TableCell>{row.classdesc || "-"}</TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {row.qty || 0}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {parseFloat(row.unitPrice).toFixed(2) || 0.0}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {parseFloat(row.discAmt).toFixed(2) || 0.0}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {parseFloat(row.taxRate).toFixed(2) || 0.0}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {parseFloat(row.taxAmt).toFixed(2) || 0.0}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc" }}>
                    {parseFloat(row.total_LineAmt).toFixed(2) || 0}
                  </TableCell>
                </TableRow>
              ))
            )}

            <TableRow>
              <TableCell
                sx={{ bgcolor: "#ccc", textAlign: "right" }}
                colSpan={7}
              >
                <Typography variant="button">Subtotal</Typography>
              </TableCell>
              <TableCell>
                {parseFloat(data.invoiceInfo.total_NettAmt).toFixed(2)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ bgcolor: "#ccc", textAlign: "right" }}
                colSpan={7}
              >
                <Typography variant="button">Total Exclude Tax</Typography>
              </TableCell>
              <TableCell>
                {parseFloat(data.invoiceInfo.total_ExcludeTax).toFixed(2)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ bgcolor: "#ccc", textAlign: "right" }}
                colSpan={7}
              >
                <Typography variant="button">Total Tax Amount</Typography>
              </TableCell>
              <TableCell>
                {parseFloat(data.invoiceInfo.total_TaxAmt).toFixed(2)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ bgcolor: "#ccc", textAlign: "right" }}
                colSpan={7}
              >
                <Typography variant="button">Total including tax</Typography>
              </TableCell>
              <TableCell>
                {parseFloat(data.invoiceInfo.total_IncludeTax).toFixed(2)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ bgcolor: "#ccc", textAlign: "right" }}
                colSpan={7}
              >
                <Typography variant="button">Total payable amount</Typography>
              </TableCell>
              <TableCell>
                {parseFloat(data.invoiceInfo.total_PayableAmt).toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
            <DetailItem
              label="Digital Signature"
              value={data.invoiceInfo.signature}
              justify="start"
            />
            <DetailItem
              label="Date and Time Validation"
              value={data.invoiceInfo.validationDate}
              justify="start"
            />
            <DetailItem
              label="This document is a visual presentation of the e-invoice"
              value=""
              justify="start"
            />
          </Grid>
          {/* <Grid item xs={12} md={6} display="flex" justifyContent="right">
            <Box maxWidth={100} >
              <QRCode
                size={256}
                style={{
                  height: "auto",
                  maxWidth: "100%",
                  width: "100%",
                }}
                value={"value"}
                viewBox={`0 0 256 256`}
              />
            </Box>
          </Grid> */}
        </Grid>
      </Box>
     </Box>
      
    </PrivateLayout>
  );
}
